export var warriorBackground = '_11eyx';
export var minHeight = '$sQrMN';
export var itemSizing = '_1IH0a';
export var itemOffsetEven = '$mk0DR';
export var sliderShadow = '$_1-ZVU';